import { OfferKindEnum } from '../../../../../services/exports/Constants';

const OfferLabel: Record<OfferKindEnum, string> = {
  [OfferKindEnum.PercentageOffByMinSpendValue]: '{{percentageAmount}}% dto. desde {{minSpendValue}}',
  [OfferKindEnum.PercentageOffByProducts]: 'Ahorra {{percentageAmount}}% en artículos seleccionados',
  [OfferKindEnum.AmountOffByProducts]: 'Ahorra {{amount}} en artículos seleccionados',
  [OfferKindEnum.AmountOffByMinSpendValue]: 'Ahorra {{amount}} desde {{minSpendValue}}',
  [OfferKindEnum.Bogo]: '2 por el precio de 1 – Solo hoy',
  [OfferKindEnum.BogoHalfPrice]: 'Compra uno y lleva otro al 50%',
  [OfferKindEnum.FreeItemByProducts]: '¡Hoy: consigue tu artículo gratis!',
  [OfferKindEnum.FreeItemByMinSpendValue]: '¡Hoy: consigue tu artículo gratis con un valor de pedido!',
};

export default OfferLabel;
